"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const arrow_down_svg_1 = __importDefault(require("../../assets/images/baseIcons/arrow-down.svg"));
const arrow_right_svg_1 = __importDefault(require("../../assets/images/baseIcons/arrow-right.svg"));
const arrow_left_svg_1 = __importDefault(require("../../assets/images/baseIcons/arrow-left.svg"));
const instagram_svg_1 = __importDefault(require("../../assets/images/baseIcons/instagram.svg"));
const facebook_svg_1 = __importDefault(require("../../assets/images/baseIcons/facebook.svg"));
const x_svg_1 = __importDefault(require("../../assets/images/baseIcons/x.svg"));
const edit_svg_1 = __importDefault(require("../../assets/images/baseIcons/edit.svg"));
const trash_svg_1 = __importDefault(require("../../assets/images/baseIcons/trash.svg"));
const filter_svg_1 = __importDefault(require("../../assets/images/baseIcons/filter.svg"));
const search_svg_1 = __importDefault(require("../../assets/images/baseIcons/search.svg"));
const web_svg_1 = __importDefault(require("../../assets/images/baseIcons/web.svg"));
const linkedin_svg_1 = __importDefault(require("../../assets/images/baseIcons/linkedin.svg"));
const copy_link_svg_1 = __importDefault(require("../../assets/images/baseIcons/copy-link.svg"));
const eye_svg_1 = __importDefault(require("../../assets/images/baseIcons/eye.svg"));
const sort_svg_1 = __importDefault(require("../../assets/images/baseIcons/sort.svg"));
const download_svg_1 = __importDefault(require("../../assets/images/baseIcons/download.svg"));
const react_1 = __importDefault(require("react"));
function BaseIcon(props) {
    function getIconByEnum(iconEnum) {
        switch (iconEnum) {
            case "arrow-down":
                return arrow_down_svg_1.default;
            case "arrow-right":
                return arrow_right_svg_1.default;
            case "arrow-left":
                return arrow_left_svg_1.default;
            case "instagram":
                return instagram_svg_1.default;
            case "facebook":
                return facebook_svg_1.default;
            case "x":
                return x_svg_1.default;
            case "edit":
                return edit_svg_1.default;
            case "trash":
                return trash_svg_1.default;
            case "filter":
                return filter_svg_1.default;
            case "search":
                return search_svg_1.default;
            case "web":
                return web_svg_1.default;
            case "linkedin":
                return linkedin_svg_1.default;
            case "copy-link":
                return copy_link_svg_1.default;
            case "eye":
                return eye_svg_1.default;
            case "sort":
                return sort_svg_1.default;
            case "download":
                return download_svg_1.default;
            default:
                return arrow_down_svg_1.default;
        }
    }
    function getAltByEnum(iconEnum) {
        switch (iconEnum) {
            case "arrow-down":
                return "arrow-down";
            case "arrow-right":
                return "arrow-right";
            case "arrow-left":
                return "arrow-left";
            case "instagram":
                return "instagram";
            case "facebook":
                return "facebook";
            case "x":
                return "x";
            case "edit":
                return "edit";
            case "trash":
                return "trash";
            case "filter":
                return "filter";
            case "search":
                return "search";
            case "web":
                return "web";
            case "linkedin":
                return "linkedin";
            case "copy-link":
                return "copy-link";
            case "eye":
                return "eye";
            case "sort":
                return "sort";
            case "download":
                return "download";
            default:
                return "arrow-down";
        }
    }
    return (react_1.default.createElement("img", { className: props.className, src: getIconByEnum(props.icon), alt: getAltByEnum(props.icon), height: 20, width: 20, style: props.styles }));
}
exports.default = BaseIcon;
